import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-dark order-2 order-md-1" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold me-1" }, "2021©"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://dineuron.com/",
    target: "_blank",
    class: "text-gray-800 text-hover-primary"
  }, "DiNeuron")
], -1)
const _hoisted_3 = { class: "text-dark order-2 order-md-1" }
const _hoisted_4 = { class: "footer_box" }
const _hoisted_5 = { class: "footer_box" }
const _hoisted_6 = { class: "footer_box" }
const _hoisted_7 = { class: "text-dark order-2 order-md-1" }
const _hoisted_8 = { class: "social-buttons" }
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-f" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-youtube" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-linkedin-in" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-codepen" }, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "payment_method_box" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/media/payments/paymentCard.png",
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mir" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "/media/payments/telcell.png",
      alt: ""
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, { to: `/page/89` }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('privacyPolicy')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: `/page/2` }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('termsOfReturns')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, { to: `/page/18` }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('termsAndConditions')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_ctx.settings.facebook)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.settings.facebook,
                class: "social-buttons__button social-button social-button--facebook",
                "aria-label": "Facebook"
              }, _hoisted_11, 8, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.settings.instagram)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.settings.instagram,
                class: "social-buttons__button social-button social-button--instagram",
                "aria-label": "Instagram"
              }, _hoisted_14, 8, _hoisted_12))
            : _createCommentVNode("", true),
          (_ctx.settings.youtube)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _ctx.settings.youtube,
                class: "social-buttons__button social-button social-button--youtube",
                "aria-label": "YouTube"
              }, _hoisted_17, 8, _hoisted_15))
            : _createCommentVNode("", true),
          (_ctx.settings.linkedin)
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: _ctx.settings.linkedin,
                class: "social-buttons__button social-button social-button--linkedin",
                "aria-label": "LinkedIn"
              }, _hoisted_20, 8, _hoisted_18))
            : _createCommentVNode("", true),
          (_ctx.settings.website)
            ? (_openBlock(), _createElementBlock("a", {
                key: 4,
                href: _ctx.settings.website,
                class: "social-buttons__button social-button social-button--codepen",
                "aria-label": "CodePen"
              }, _hoisted_23, 8, _hoisted_21))
            : _createCommentVNode("", true)
        ]),
        _hoisted_24
      ])
    ], 2)
  ]))
}